import { Component, Directive, Input, ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FIKO_DIALOG_STIL } from './fiko-dialog-stil';
import { FikoSecimListesi } from './FikoSecimListesi';

/** Ortak temel: set/setNum + kapat/sil + pencere. */
@Directive()
class FikoDialogTaban implements OnDestroy {
  @Input() element: any;
  @Input() yonetici: any;
  @Input() pencere: any;
  constructor(public CD: ChangeDetectorRef) {}
  ngOnDestroy(): void { this.yonetici?.dialogSecimTemizle?.(this.element); }   // X/kapanış dâhil seçim modunu kökten temizle
  get el() { return this.element; }
  get yon() { return this.yonetici; }
  set(a: string, v: any): void { this.yonetici?.padGuncelle(this.element, a, v); this.CD.markForCheck(); }
  setNum(a: string, v: any): void { const n = +v; if (!isNaN(n)) this.yonetici?.padGuncelle(this.element, a, n); this.CD.markForCheck(); }
  cizgiler(): any[] { return this.yonetici?.egriSecenekleri?.(this.element) || []; }
  ref3d(anahtar: string, tip: string): void { this.yonetici?.refSecBaslat?.(this.element, anahtar, [tip], () => this.CD.markForCheck()); }
  protected kapat(): void { this.yonetici?.featureSecimBitir?.(); (this.pencere?.instance || this.pencere)?.kapa?.(); }
  tamam(): void { this.kapat(); }
  sil(): void { this.yonetici?.featureSil(this.element); this.kapat(); }
}

// ───────────────────── FILLET / CHAMFER (kenar işlemi) ─────────────────────
@Component({
  selector: 'fikoyt-fillet-dialog', standalone: true, changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule, FikoSecimListesi],
  template: `
  <div class="sd" *ngIf="el && yon">
    <div class="sd-grup">
      <div class="sd-bas">{{ fillet ? 'Yuvarlatma (Fillet)' : 'Pah (Chamfer)' }}</div>
      <div class="sd-row"><label>{{ fillet ? (el.degiskenFillet ? 'Yarıçap 1' : 'Yarıçap') : 'Mesafe' }}</label><div class="sd-num"><input type="number" min="0.1" step="0.5" [ngModel]="el.kenarMesafe ?? 4" (ngModelChange)="setNum('kenarMesafe',$event)"/><span>mm</span></div></div>
      @if(fillet){
        <label class="sd-chk"><input type="checkbox" [ngModel]="!!el.degiskenFillet" (ngModelChange)="set('degiskenFillet',$event)"/> 📐 Değişken Yarıçap (r1→r2)</label>
        @if(el.degiskenFillet){
          <div class="sd-row"><label>Yarıçap 2</label><div class="sd-num"><input type="number" min="0.1" step="0.5" [ngModel]="el.kenarMesafe2 ?? 8" (ngModelChange)="setNum('kenarMesafe2',$event)"/><span>mm</span></div></div>
          <div class="sd-bos">Yarıçap kenar boyunca r1'den r2'ye değişir (kenar seçimi zorunlu).</div>
        }
      }
    </div>
    <div class="sd-grup">
      <div class="sd-bas">Propagasyon</div>
      <div class="sd-seg">
        <button [class.aktif]="!yon.tangencyDurum" (click)="prop(false)">Minimal</button>
        <button [class.aktif]="yon.tangencyDurum" (click)="prop(true)">Tanjant</button>
      </div>
      <div class="sd-bos">Tanjant: teğet süreklilikteki komşu kenarlar birlikte seçilir.</div>
    </div>
    <div class="sd-grup">
      <fikoyt-secim-listesi [element]="el" [yonetici]="yon" [tip]="'kenar'"></fikoyt-secim-listesi>
      <div class="sd-bos">Seçim yoksa TÜM keskin kenarlara uygulanır.</div>
    </div>
    <div class="sd-altbar"><button class="sd-btn sd-ok" (click)="tamam()">✔ Tamam</button><button class="sd-btn sd-sil" (click)="sil()">🗑</button></div>
  </div>`,
  styles: [FIKO_DIALOG_STIL]
})
export class FikoFilletDialog extends FikoDialogTaban {
  get fillet(): boolean { return this.element?.tip === 'fillet3d'; }
  get secVar(): boolean { return (this.element?.secKenarlar?.length || 0) >= 3; }
  prop(t: boolean): void { if (!!this.yonetici.tangencyDurum !== t) this.yonetici.tangencyToggle?.(); this.CD.markForCheck(); }
  kenarSec(): void { this.yonetici?.featureKenarSec?.(this.element); }
}

// ───────────────────── DRAFT (eğim) ─────────────────────
@Component({
  selector: 'fikoyt-draft-dialog', standalone: true, changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule, FikoSecimListesi],
  template: `
  <div class="sd" *ngIf="el && yon">
    <div class="sd-grup">
      <div class="sd-bas">Eğim Açısı</div>
      <div class="sd-row"><label>Açı</label><div class="sd-num"><input type="number" min="0" max="89" step="1" [ngModel]="el.aci ?? 5" (ngModelChange)="setNum('aci',$event)"/><span>°</span></div></div>
    </div>
    <div class="sd-grup">
      <div class="sd-bas">Çekme Yönü (Pulling Direction)</div>
      <div class="sd-row"><label>Eksen</label>
        <select [ngModel]="el.eksenTip || 'z'" (ngModelChange)="set('eksenTip',$event)">
          <option value="x">X Ekseni</option><option value="y">Y Ekseni</option><option value="z">Z Ekseni</option>
        </select></div>
    </div>
    <div class="sd-grup">
      <div class="sd-bas">Nötr Eleman</div>
      <div class="sd-row"><label>Nötr Düzlem</label>
        <select [ngModel]="el.taban || 'alt'" (ngModelChange)="set('taban',$event)">
          <option value="alt">Alt</option><option value="orta">Orta</option><option value="ust">Üst</option>
        </select></div>
    </div>
    <div class="sd-grup">
      <fikoyt-secim-listesi [element]="el" [yonetici]="yon" [tip]="'yuz'"></fikoyt-secim-listesi>
    </div>
    <div class="sd-altbar"><button class="sd-btn sd-ok" (click)="tamam()">✔ Tamam</button><button class="sd-btn sd-sil" (click)="sil()">🗑</button></div>
  </div>`,
  styles: [FIKO_DIALOG_STIL]
})
export class FikoDraftDialog extends FikoDialogTaban {
  get secVar(): boolean { return (this.element?.secYuzNok?.length || 0) >= 3; }
  yuzSec(): void { this.yonetici?.featureYuzSec?.(this.element); }
}

// ───────────────────── SHELL (kabuk) ─────────────────────
@Component({
  selector: 'fikoyt-shell-dialog', standalone: true, changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule, FikoSecimListesi],
  template: `
  <div class="sd" *ngIf="el && yon">
    <div class="sd-grup">
      <div class="sd-bas">Kabuk (içi boşalt)</div>
      <div class="sd-row"><label>Et Kalınlığı</label><div class="sd-num"><input type="number" min="0.1" step="0.5" [ngModel]="el.kalinlik ?? 4" (ngModelChange)="setNum('kalinlik',$event)"/><span>mm</span></div></div>
    </div>
    <div class="sd-grup">
      <fikoyt-secim-listesi [element]="el" [yonetici]="yon" [tip]="'yuz'"></fikoyt-secim-listesi>
      <div class="sd-bos">Seçilen yüzler açık kalır; seçim yoksa tamamen kapalı kabuk.</div>
    </div>
    <div class="sd-altbar"><button class="sd-btn sd-ok" (click)="tamam()">✔ Tamam</button><button class="sd-btn sd-sil" (click)="sil()">🗑</button></div>
  </div>`,
  styles: [FIKO_DIALOG_STIL]
})
export class FikoShellDialog extends FikoDialogTaban {
  get secVar(): boolean { return (this.element?.secYuzNok?.length || 0) >= 3; }
  yuzSec(): void { this.yonetici?.featureYuzSec?.(this.element); }
}

// ───────────────────── PATTERN (dizi) ─────────────────────
@Component({
  selector: 'fikoyt-pattern-dialog', standalone: true, changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule],
  template: `
  <div class="sd" *ngIf="el && yon">
    @if(el.tip === 'patternDik'){
      <div class="sd-grup"><div class="sd-bas">Doğrusal Dizi (Rectangular)</div>
        <div class="sd-row"><label>Örnek Sayısı</label><div class="sd-num"><input type="number" min="1" step="1" [ngModel]="el.adet ?? 4" (ngModelChange)="setNum('adet',$event)"/><span>×</span></div></div>
        <div class="sd-row"><label>Aralık</label><div class="sd-num"><input type="number" min="0.1" step="1" [ngModel]="el.aralik ?? 40" (ngModelChange)="setNum('aralik',$event)"/><span>mm</span></div></div>
      </div>
    } @else if(el.tip === 'patternDairesel'){
      <div class="sd-grup"><div class="sd-bas">Dairesel Dizi (Circular)</div>
        <div class="sd-row"><label>Örnek Sayısı</label><div class="sd-num"><input type="number" min="1" step="1" [ngModel]="el.adet ?? 6" (ngModelChange)="setNum('adet',$event)"/><span>×</span></div></div>
        <div class="sd-row"><label>Açısal Adım</label><div class="sd-num"><input type="number" min="1" max="360" step="5" [ngModel]="el.aci ?? 60" (ngModelChange)="setNum('aci',$event)"/><span>°</span></div></div>
      </div>
    } @else {
      <div class="sd-grup"><div class="sd-bas">Izgara Dizi (Grid)</div>
        <div class="sd-row"><label>Sıra</label><div class="sd-num"><input type="number" min="1" step="1" [ngModel]="el.adet ?? 3" (ngModelChange)="setNum('adet',$event)"/></div></div>
        <div class="sd-row"><label>Sütun</label><div class="sd-num"><input type="number" min="1" step="1" [ngModel]="el.adet2 ?? 3" (ngModelChange)="setNum('adet2',$event)"/></div></div>
        <div class="sd-row"><label>Aralık (U)</label><div class="sd-num"><input type="number" min="0.1" step="1" [ngModel]="el.aralik ?? 40" (ngModelChange)="setNum('aralik',$event)"/><span>mm</span></div></div>
        <div class="sd-row"><label>Aralık (V)</label><div class="sd-num"><input type="number" min="0.1" step="1" [ngModel]="el.aralik2 ?? 40" (ngModelChange)="setNum('aralik2',$event)"/><span>mm</span></div></div>
      </div>
    }
    <div class="sd-altbar"><button class="sd-btn sd-ok" (click)="tamam()">✔ Tamam</button><button class="sd-btn sd-sil" (click)="sil()">🗑</button></div>
  </div>`,
  styles: [FIKO_DIALOG_STIL]
})
export class FikoPatternDialog extends FikoDialogTaban {}

// ───────────────────── TRANSFORM (taşı/döndür/simetri/ölçek/ayna) ─────────────────────
@Component({
  selector: 'fikoyt-transform-dialog', standalone: true, changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule],
  template: `
  <div class="sd" *ngIf="el && yon">
    @if(el.tip === 'translate'){
      <div class="sd-grup"><div class="sd-bas">Taşı (Translate)</div>
        <div class="sd-row"><label>X</label><div class="sd-num"><input type="number" step="1" [ngModel]="el.trX ?? 0" (ngModelChange)="setNum('trX',$event)"/><span>mm</span></div></div>
        <div class="sd-row"><label>Y</label><div class="sd-num"><input type="number" step="1" [ngModel]="el.trY ?? 0" (ngModelChange)="setNum('trY',$event)"/><span>mm</span></div></div>
        <div class="sd-row"><label>Z</label><div class="sd-num"><input type="number" step="1" [ngModel]="el.trZ ?? 0" (ngModelChange)="setNum('trZ',$event)"/><span>mm</span></div></div>
      </div>
    } @else if(el.tip === 'rotate'){
      <div class="sd-grup"><div class="sd-bas">Döndür (Rotate)</div>
        <div class="sd-row"><label>Açı</label><div class="sd-num"><input type="number" min="-360" max="360" step="5" [ngModel]="el.aci ?? 45" (ngModelChange)="setNum('aci',$event)"/><span>°</span></div></div>
        @if((el.eksenRef ?? -1) < 0){
          <div class="sd-row"><label>Eksen</label><select [ngModel]="el.eksenTip || 'z'" (ngModelChange)="set('eksenTip',$event)"><option value="x">X</option><option value="y">Y</option><option value="z">Z</option></select></div>
        }
        <div class="sd-row"><label>3D Çizgi Ekseni</label>
          <select [ngModel]="el.eksenRef ?? -1" (ngModelChange)="setNum('eksenRef',$event)">
            <option [value]="-1">— X/Y/Z kullan —</option>
            @for(o of cizgiler(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }
          </select><button class="sd-pick" (click)="ref3d('eksenRef','cizgi3d')" title="3D'den çizgi seç">🎯</button></div>
      </div>
    } @else if(el.tip === 'scaling'){
      <div class="sd-grup"><div class="sd-bas">Ölçekle (Scaling)</div>
        <div class="sd-row"><label>Katsayı</label><div class="sd-num"><input type="number" min="0.01" step="0.1" [ngModel]="el.scaleFaktor ?? 1.5" (ngModelChange)="setNum('scaleFaktor',$event)"/><span>×</span></div></div>
      </div>
    } @else {
      <div class="sd-grup"><div class="sd-bas">{{ el.tip === 'symmetry' ? 'Simetri (Symmetry)' : 'Aynala (Mirror)' }}</div>
        <div class="sd-row"><label>Düzlem</label><select [ngModel]="el.aynaTip || 'yz'" (ngModelChange)="set('aynaTip',$event)"><option value="xy">XY</option><option value="xz">XZ</option><option value="yz">YZ</option></select></div>
        <div class="sd-bos">{{ el.tip === 'symmetry' ? 'Gövde aynalanmış konuma TAŞINIR.' : 'Aynalanmış kopya EKLENİR.' }}</div>
      </div>
    }
    <div class="sd-altbar"><button class="sd-btn sd-ok" (click)="tamam()">✔ Tamam</button><button class="sd-btn sd-sil" (click)="sil()">🗑</button></div>
  </div>`,
  styles: [FIKO_DIALOG_STIL]
})
export class FikoTransformDialog extends FikoDialogTaban {}
